import InStoreRewards from '@fhs-legacy/frontend/src/pages/in-store-rewards';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default InStoreRewards;
